/** Larghezza drawer form crash su desktop (px). */
export const DESKTOP_FORM_DRAWER_WIDTH_PX = 800

/** Larghezza drawer crash history su desktop (px). */
export const DESKTOP_HISTORY_DRAWER_WIDTH_PX = 480

/** Colonne campi form su desktop (mobile resta a colonna singola). */
export const DESKTOP_FORM_FIELD_COLUMNS = 2
